import { Formik, Form, Field } from 'formik'
import Button from '../../../../elements/Button'
import styles from './styles.module.scss'
import axios from '/components/configs/axios'
import { useState } from 'react'
import { useModalContext } from '../../../../../providers/modalProvider'
import Message from '../../../../custom/Message'
import { withModifiers } from '../../../../helpers/withModifiers'
import { useRouter } from 'next/router'

const Subscribe = ({ variant = [], translations }) => {
  const [mails, setMails] = useState([])
  const { handleShowModal, setContent, setVariant } = useModalContext()
  const isLarge = variant.includes('large')
  const router = useRouter()

  const formInitialValues = {
    email: ''
  }

  const validationSchema = (values) => {
    const errors = {}
    if (values.email !== '') {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = translations.error.emailError[router.locale]
      }
    }
    return errors
  }

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true)
    axios
      .post('active/pipe', {
        email: values.email
      })
      .then((res) => {
        if (
          res.data[0]?.error?.includes(
            translations.error.emailExists[router.locale]
          )
        ) {
          setMails([...mails, values.email])
        } else {
          setVariant(['contained', 'xs'])
          setContent(
            <Message
              title={translations.success.title[router.locale]}
              subtitle={
                <>
                  {translations.success.subtitle[router.locale]}
                  <a rel="nofollow" href="mailto:reservations@sxmsir.com">
                    reservations@sxmsir.com
                  </a>
                </>
              }
              button={{
                label: translations.success.button[router.locale],
                href: '/vacation-rentals'
              }}
            />
          )
          handleShowModal()
        }
      })
      .catch((err) => console.error(err))
    setSubmitting(false)
  }

  return (
    <Formik
      initialValues={formInitialValues}
      enableReinitialize
      validate={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, errors, touched, handleChange, handleBlur }) => {
        const disabled =
          values.email === formInitialValues.email ||
          mails.includes(values.email) ||
          (errors.email && touched.email)
        return (
          <Form className={withModifiers('form', [...variant], styles)}>
            <Field
              type="email"
              name="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              placeholder={
                isLarge
                  ? translations.fields.email[router.locale]
                  : translations.fields.subscribe[router.locale]
              }
              className={styles.form__field}
            />
            <div className={styles.form__error}>
              {errors.email && touched.email && errors.email}
              {mails.includes(values.email) &&
                translations.error.subscribed[router.locale]}
            </div>

            {!disabled && (
              <Button
                variant={[isLarge ? 'primary-blue' : 'secondary']}
                name="subscribe"
                className={styles.form__button}
              >
                {isLarge ? translations.fields.submit[router.locale] : ''}
              </Button>
            )}
          </Form>
        )
      }}
    </Formik>
  )
}

export default Subscribe
